"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDashboardDefinition = exports.isDashboard = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * Tests whether the provided object is an instance of {@link IDashboard}.
 *
 * @param obj - object to test
 * @alpha
 */
function isDashboard(obj) {
    var asDash = obj;
    return !isEmpty_1.default(asDash) && asDash.type === "IDashboard" && asDash.ref !== undefined;
}
exports.isDashboard = isDashboard;
/**
 * Tests whether the provided object is an instance of {@link IDashboardDefinition}.
 *
 * @param obj - object to test
 * @alpha
 */
function isDashboardDefinition(obj) {
    var asDash = obj;
    return !isEmpty_1.default(asDash) && asDash.type === "IDashboard";
}
exports.isDashboardDefinition = isDashboardDefinition;
//# sourceMappingURL=dashboard.js.map